import { useState } from "react";
import Pagination from "@mui/material/Pagination";
import { Box, Stack, Typography } from "@mui/material";
import ExerciseCard from "../../../components/ExerciseCard";

const Exercises = ({ exercises, search }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const exercisePerPage = 9;

  const endOfCurrentPage = currentPage * exercisePerPage;

  const startofCurrentPage = endOfCurrentPage - exercisePerPage;

  const currentExercises = exercises.slice(
    startofCurrentPage,
    endOfCurrentPage
  );

  const paginate = ({ value }) => {
    setCurrentPage(value);

    document.getElementById("exercises").scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <Box id="exercises" sx={{ mt: { lg: "110px" } }} mt="50px" p="20px">
      <Typography variant="h3" mb="46px">
        Showing Result {search !== "" ? `for ${search}` : ""}
      </Typography>
      <Stack
        direction="row"
        sx={{ gap: { lg: "110px", xs: "50px" } }}
        flexWrap="wrap"
        justifyContent="center"
      >
        {currentExercises.length > 0 ? (
          currentExercises.map((exercise, index) => (
            <ExerciseCard key={index} exercise={exercise} />
          ))
        ) : (
          <Typography variant="h5">No exercise Found for {search}</Typography>
        )}
      </Stack>
      <Stack mt="100px" alignItems="center">
        {exercises.length > exercisePerPage ? (
          <Pagination
            color="standard"
            shape="rounded"
            count={Math.ceil(exercises.length / exercisePerPage)}
            page={currentPage}
            onChange={paginate}
          />
        ) : (
          ""
        )}
      </Stack>
    </Box>
  );
};

export default Exercises;
